import compact from 'lodash/compact'
import map from 'lodash/map'

import { ImagePin as ImagePinGraphQL, Maybe } from '@Generated/graphql'

export interface ImagePin {
  id: string
  type: string
  x: number
  y: number
}
export interface Image {
  dimensions: {
    height: number
    width: number
  }
  pins?: ImagePin[]
  url: string
}

export function convertGraphQLPins(pins: Maybe<ImagePinGraphQL[]> | undefined): ImagePin[] {
  return compact(map(pins || [], (pin) => {
    if (!pin || !pin.reference?.id || pin.reference.__typename !== 'Page' || !pin.reference.type) {
      return null
    }

    return {
      id: pin.reference.id,
      type: pin.reference.type,
      x: pin.x || 0,
      y: pin.y || 0,
    }
  }))
}
